import PageLayout from '@/components/feature/PageLayout';
import AboutIntro from '@/pages/about/components/AboutIntro';
import AboutPlatforms from '@/pages/about/components/AboutPlatforms';
import PartnerProgram from '@/pages/about/components/PartnerProgram';

export default function AboutPage() {
  return (
    <PageLayout>
      <AboutIntro />
      <AboutPlatforms />
      <PartnerProgram />
    </PageLayout>
  );
}